import React from 'react';
import { CheckIcon, DownloadIcon } from 'lucide-react';
import { CheckoutButton } from '../CheckoutButton';
import { CollectionMockup } from '../CollectionMockup';
import { StitchLine } from '../StitchLine';
import { OFFER_FEATURES } from '../../data/collection';
import { BUY_LABEL, PRICE } from '../../data/checkout';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-title" className="w-full bg-ivory-deep" data-id="element-259" data-mp="akwackide8hz">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 lg:py-24" data-id="element-260" data-mp="6jay91dnty8u">
        <div className="grid items-center gap-10 rounded-[28px] bg-paper p-5 ring-1 ring-ivory-line sm:p-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-14 lg:p-12" data-id="element-261" data-mp="1ppxj1komq5y">
          <div className="order-2 lg:order-1" data-id="element-262" data-mp="3ny7y8lb2lr4x">
            <CollectionMockup data-id="element-263" data-mp="3nzj18iwoyuuz" />
          </div>

          <div className="order-1 lg:order-2" data-id="element-264" data-mp="3iz4t70v3bkwy">
            <StitchLine className="w-16" data-id="element-265" data-mp="3ixtomyttm94s" />
            <h2 id="oferta-title" className="mt-4 font-serif text-[2rem] font-semibold leading-[1.1] text-graphite text-balance sm:text-[2.5rem]" data-id="element-266" data-mp="3ex9ve6cdbpnx">
              Llevate la colección completa de Pequeñas Puntadas™.
            </h2>

            <ul className="mt-6 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-267" data-mp="1fkk06ynf2c48">
              {OFFER_FEATURES.map(feature => <li key={feature} className="flex items-start gap-2.5 text-[1.02rem] font-semibold text-graphite" data-id="element-268" data-mp="15so05i1rsbxd">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-tint" data-id="element-269" data-mp="1ti8ko5dknh8r">
                    <CheckIcon className="h-3.5 w-3.5 text-sage-ink" strokeWidth={3} aria-hidden data-id="element-270" data-mp="1yga5auqnbomc" />
                  </span>
                  {feature}
                </li>)}
            </ul>

            <div id="offer-price" className="mt-8 border-t border-ivory-line pt-6" data-id="element-271" data-mp="1oi46im04yylp">
              <p className="text-[0.98rem] text-graphite-soft" data-id="element-272" data-mp="91lqkmul1ul5">
                Precio de referencia <span className="font-semibold line-through" data-id="element-273" data-mp="d4if0u6t0kx0">{PRICE.compareAtLabel}</span>
              </p>
              <p className="mt-1 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-274" data-mp="2fpvvc53uiwc9">
                <span className="font-serif text-[3.2rem] font-semibold leading-none text-graphite sm:text-[3.6rem]" data-id="element-275" data-mp="2arav45olgcnt">
                  {PRICE.label}
                </span>
                <span className="text-[1rem] font-bold text-graphite-soft" data-id="element-276" data-mp="25yrhx9ttjjjj">ARS · {PRICE.note}</span>
              </p>
            </div>

            <div className="relative mt-6 rounded-[16px] bg-blush px-5 py-5 sm:px-6" data-id="element-277" data-mp="1x0pkt5d7hb1j">
              <span aria-hidden className="pointer-events-none absolute inset-[6px] rounded-[11px] border border-dashed border-coral/50" data-id="element-278" data-mp="1s0tgt64idjlz" />
              <p className="relative font-serif text-[1.2rem] font-semibold text-graphite" data-id="element-279" data-mp="1n2rxql731kai">{PRICE.perModelLead}</p>
              <p className="relative mt-1 font-serif text-[1.65rem] font-semibold leading-tight text-coral-ink sm:text-[1.85rem]" data-id="element-280" data-mp="1i4ztqst5y7py">
                {PRICE.perModelHighlight}
              </p>
              <p className="relative mt-1.5 text-[0.9rem] font-semibold text-graphite-soft" data-id="element-281" data-mp="3chpspoye2747">{PRICE.perModelNote}</p>
            </div>

            <div className="mt-7" data-id="element-282" data-mp="3ozsch1qvxgp7">
              <CheckoutButton id="offer-cta" label={BUY_LABEL} size="lg" data-id="element-283" data-mp="3oyqpbywlh3r4" />
            </div>
            <p className="mt-4 flex items-start gap-2 text-[0.95rem] leading-relaxed text-graphite-soft" data-id="element-284" data-mp="3tq8smtm3bgf9">
              <DownloadIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage-ink" aria-hidden data-id="element-285" data-mp="2j5z3vis4y1v" />
              {PRICE.delivery} Son archivos digitales: no se envían productos físicos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}